import React from 'react';
import Checkbox from '../Checkbox';
import NumberInput from '../Number/refactor_index';
export default class OtherSettings extends React.Component {
    constructor(props) {
        super(props);
    }
    // 自动折行
    ellipsisChange = () => {
        let { isEllipsis, ellipsisChange } = this.props;
        ellipsisChange && ellipsisChange(!isEllipsis);
    }
    saveWidthHandler = () => {
        let { saveWidthFlag, saveWidthHandler } = this.props;
        saveWidthHandler && saveWidthHandler(!saveWidthFlag);
    }
    resetWidthHandler = () => {
        let { resetWidthFlag, resetWidthHandler } = this.props;
        resetWidthHandler && resetWidthHandler(!resetWidthFlag);
    }
    setTableHeightHandler = value => {
        let { setTableHeightHandler } = this.props;
        setTableHeightHandler && setTableHeightHandler(value);
    }
    showSubTotalHandler = () => {
        let { showSubTotalFlag, showSubTotalHandler } = this.props;
        showSubTotalHandler && showSubTotalHandler(!showSubTotalFlag);
    }
    render() {
        const { isEllipsis, saveWidthFlag = false, resetWidthFlag = false, tableHeight = 30, showSubTotalFlag = false } = this.props;
        return (
            <div className="otherSettings">
                <div className="widthHeightSetting">
                    <div className="title">宽高设置：</div>
                    <div className="content">
                        <span className="label">自动换行</span>
                        <Checkbox
                            checked={!isEllipsis}
                            onChange={this.ellipsisChange}
                        />
                    </div>
                    <div className="content">
                        <span className="label">保存列宽</span>
                        <Checkbox
                            checked={saveWidthFlag}
                            onChange={this.saveWidthHandler}
                        >
                        </Checkbox>
                    </div>
                    <div className="content">
                        <span className="label">重置列宽</span>
                        <Checkbox
                            checked={resetWidthFlag}
                            onChange={this.resetWidthHandler}
                        >
                        </Checkbox>
                    </div>
                    <div className="content">
                        <span className="label">调整表格高度至</span>
                        <NumberInput
                            className="inputText"
                            value={tableHeight}
                            onChange={value => this.setTableHeightHandler(value)}
                            maxLength={3}
                        // autoFocus={true}
                        />
                        <span className="suffix">px</span>
                    </div>
                </div>
                <div className="middleLine"></div>
                <div className="totalSetting">
                    <div className="title">合计设置：</div>
                    <div className="content">
                        <span className="label">显示小计</span>
                        <Checkbox
                            className="input"
                            checked={showSubTotalFlag}
                            onChange={this.showSubTotalHandler}
                        >
                        </Checkbox>
                    </div>
                </div>
            </div>
        )
    }
}